module.exports = __webpack_public_path__ + "static/media/BebasNeue-Pro-Light.5de5c63c.otf";